var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavouriteIconNotLiked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0673 20.3667L16.0007 20.4333L15.9273 20.3667C12.7607 17.4933 10.6673 15.5933 10.6673 13.6667C10.6673 12.3333 11.6673 11.3333 13.0007 11.3333C14.0273 11.3333 15.0273 12 15.3807 12.9067H16.6207C16.974 12 17.974 11.3333 19.0007 11.3333C20.334 11.3333 21.334 12.3333 21.334 13.6667C21.334 15.5933 19.2407 17.4933 16.0673 20.3667ZM19.0007 10C17.8407 10 16.7273 10.54 16.0007 11.3867C15.274 10.54 14.1607 10 13.0007 10C10.9473 10 9.33398 11.6067 9.33398 13.6667C9.33398 16.18 11.6007 18.24 15.034 21.3533L16.0007 22.2333L16.9673 21.3533C20.4007 18.24 22.6673 16.18 22.6673 13.6667C22.6673 11.6067 21.054 10 19.0007 10Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteIconNotLiked);
export default __webpack_public_path__ + "static/media/favouriteIconNotLiked.7fc75a68fa1d33abbcde23dcdc24f1b6.svg";
export { ForwardRef as ReactComponent };